import { useMemo } from 'react';
import propTypes from 'prop-types';
import { BarChart, defaultChartColors } from '@components';
import { legendConfig } from '../chart-config';

// Compact wrapper around BarChart for the participation buckets. Accepts an
// optional `title` and `header` so consumers can drive the headline metric
// the same way other dashboard cards do (Stamps issued, Avg transaction
// value, …), keeping all chart cards visually consistent.
const ParticipationChart = ({ data, title = 'Campaign Participation', header, info }) => {
  // chartData identity must be stable across renders — react-chartjs-2
  // destroys and re-instantiates the canvas whenever the data object changes,
  // which causes visible flicker on every parent re-render otherwise.
  const chartData = useMemo(
    () => ({
      labels: data.map(entry => entry.key),
      backgroundColors: [[defaultChartColors[0]], [defaultChartColors[1]]],
      barTitle: ['Opted-In', 'Opted-Out'],
      data: [
        data.map(entry => parseInt(entry.optedIn, 10)),
        data.map(entry => parseInt(entry.optedOut, 10)),
      ],
    }),
    [data],
  );

  return (
    <BarChart
      title={title}
      header={header}
      info={info}
      chartData={chartData}
      legendConfig={legendConfig}
    />
  );
};

ParticipationChart.propTypes = {
  data: propTypes.any,
  title: propTypes.string,
  header: propTypes.object,
  info: propTypes.node,
};

export default ParticipationChart;
